import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from 'src/app/state/app.selectors';
import * as fromPlantPlanet from './plant-planet.reducers';

export interface PlantPlanetState {
  stateData: fromPlantPlanet.State;
}

export interface State extends fromRoot.AppState {
  plantPlanet: PlantPlanetState;
}

export const reducers = {
  stateData: fromPlantPlanet.reducer
};

export const selectPlantPlanetState = createFeatureSelector<PlantPlanetState>('plantPlanet');

export const selectPlantPlanetStateData = createSelector(selectPlantPlanetState, (state: PlantPlanetState) => state.stateData);

export const getPlantPlanetState = createSelector(selectPlantPlanetStateData, fromPlantPlanet.getStateData);

export const getPlantPlanetScreenError = createSelector(selectPlantPlanetStateData, fromPlantPlanet.getError);

export const getPlantPlanetScreenPending = createSelector(selectPlantPlanetStateData, fromPlantPlanet.getPending);